<template>
  <footer class="footer footer-background-color">
    <div class="container">
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-6">
          <div class="copyright">
            公司名稱：清華量子財務顧問股份有限公司
          </div>
          <div class="copyright">
            統編：24851851
          </div>
          <div class="copyright">
            客服信箱：<a :href="'mailto:' + email">{{ email }}</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      email: 'thtsai@mx.nthu.edu.tw',
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
.footer-background-color {
  background-color: #F4F5F6;
}
</style>
